<template>
  <div id="app">
    <el-container>
      <el-header height="160px"
         v-show="$route.path !== '/ipInfo'" ><Header @getStatus='getStatus' :style="{backgroundColor: top? 'rgb(15, 2, 32)': 'transparent'}"/>
        <div style="height:160px,"></div>
      </el-header>
      <el-main style="padding:0"><router-view :sign='sign'/></el-main>
      <div v-show="$route.path !== '/ipInfo'"><Footer/></div>
    </el-container>

  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
  data(){
    return {
      top:0,
      sign:false
    }
  },
  created(){
     this.sign = !!sessionStorage["token"] || false;
     this.$store.dispatch('loadSiteConfig').then(config => {
       if (config && config.siteTitle) {
         document.title = config.siteTitle;
       }
       if (config && config.tawkId) {
         this.injectTawk(config.tawkId);
       }
     });
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.handleScroll)
    })
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  },
  methods:{
    handleScroll(){
      this.top = document.documentElement.scrollTop || document.body.scrollTop;
    },
    getStatus(){
      this.sign = sessionStorage["token"] || false;
    },
    injectTawk(tawkId) {
      if (window.Tawk_API) return;
      if (!tawkId) return;
      // 兼容完整链接：提取 chat/ 后面的 propertyId/widgetId
      let id = String(tawkId).trim();
      const idx = id.indexOf('chat/');
      if (idx !== -1) {
        id = id.substring(idx + 5);
      }
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
      const s1 = document.createElement("script");
      const s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/' + id;
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    }
  },
  components: {
    Header,
    Footer
  },
  // watch:{
  //   '$route.path':{
  //     immediate: true,
  //     handler(val){
  //       console.log(val)
  //     }
  //   }
  // }
};
</script>

<style lang="less">
#app {
  transition: margin-left 0.28s;
  position: relative;
  background-color: #43275e!important;
  background-image:  url("../src/images/bg.png");
  background-repeat: repeat-y;
}
</style>



// WEBPACK FOOTER //
// src/App.vue